/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2023] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import cleanUpResponse from '@/util/cleanUpResponse';
import Session from '@/Session';

export default async function SendEmailContractExpirationReminder(formData) {
  const response = await $.soap({
    body: {
        SendEmailContractExpirationReminder: {
        $xmlns: 'http://dla.mil/ems/bpm/email',
        PIINSPIIN: formData.piinSpiin,
        ContractEndDate: formData.contractEndDate,
        ContractPOCs: {
            POC: formData.formattedPOCs
        },
        AdminID: Session.user.id
      }
    }
  });

  cleanUpResponse(response);
  return response;
}
